import { NormalizedPicksSelection, PicksSelection } from '@/types/domain';

export const areOptionIdsEqual = (
  firstOptionId: PicksSelection['option_id'] | undefined,
  secondOptionId: PicksSelection['option_id'] | undefined,
): boolean => Number(firstOptionId) === Number(secondOptionId);

export const getNormalizedSelections = (
  selections: PicksSelection[],
): NormalizedPicksSelection => {
  return selections.reduce((result, selection) => {
    result[selection.question_id] = selection;
    return result;
  }, {} as NormalizedPicksSelection);
};
